export default __webpack_public_path__ + "static/media/emergency-advisor.cf760976.png";